import React, { useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { pageSamples } from '../data/content';
export function InsidePages() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState<number>(0);
  const total = pageSamples.length;
  const goTo = (next: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(total - 1, next));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setIndex(clamped);
  };
  const handleScroll = () => {
    const track = trackRef.current;
    if (!track || track.clientWidth === 0) return;
    const current = Math.round(track.scrollLeft / track.clientWidth);
    if (current !== index) setIndex(current);
  };
  return <section id="inside-pages" className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-112" data-mp="3pmeu5g2ssjhh">
      <div className="mx-auto max-w-5xl" data-id="element-113" data-mp="3kvq3g2yxzqje">
        <div className="mx-auto max-w-2xl text-center" data-id="element-114" data-mp="3kuogp18kdflu">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-115" data-mp="1mmmdnghh7ttw">
            Blick ins Material
          </span>
          <h2 className="mt-5 font-display text-[1.8rem] font-black leading-tight tracking-tight text-ink sm:text-[2.6rem]" data-id="element-116" data-mp="1rk4d8g9lswp8">
            Echte <span className="italic text-brand" data-id="element-117" data-mp="1dry7lo42u841">Seiten-Beispiele.</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-118" data-mp="1htt9atpx6nic">
            Echte Seiten aus dem Paket – von den Sequenzen der Grundlagen bis zu den
            Progressions-Trackern der Meisterschaft.
          </p>
        </div>

        <div ref={trackRef} onScroll={handleScroll} role="group" aria-roledescription="Karussell" aria-label="Beispielseiten aus dem Material" tabIndex={0} onKeyDown={event => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(index + 1);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(index - 1);
        }
      }} className="no-scrollbar mt-10 flex w-full snap-x snap-mandatory overflow-x-auto overscroll-x-contain rounded-3xl focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30" data-id="element-119" data-mp="uvolqemxod9h">
          {pageSamples.map((page, pageIndex) => <article key={page.src} aria-roledescription="Folie" aria-label={`${pageIndex + 1} von ${total}`} className="w-full min-w-0 shrink-0 snap-start" data-id="element-120" data-mp="3oab89ibjjm3y" data-mpi={pageIndex}>
              <div className="grid gap-6 md:grid-cols-2 md:items-center md:gap-8" data-id="element-121" data-mp="fzzwuqc1dct1">
                <div className="relative min-w-0 overflow-hidden rounded-3xl bg-white p-3 shadow-soft sm:p-4" data-id="element-122" data-mp="b1g86i625mwz">
                  <img src={page.src} alt={`${page.title} — Beispielseite, ${page.level}`} loading={pageIndex === 0 ? 'eager' : 'lazy'} className="block h-auto w-full rounded-xl" data-id="element-123" data-mp="18gkg8ogipa9k" />
                  <button type="button" onClick={() => goTo(pageIndex - 1)} aria-label="Vorherige Seite" className="absolute left-4 top-1/2 z-10 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-ink/90 text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:scale-105 hover:bg-brand focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:left-6" data-id="element-124" data-mp="1b3la336wzdqx">
                    <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-125" data-mp="23pnyko682ddl" />
                  </button>
                  <button type="button" onClick={() => goTo(pageIndex + 1)} aria-label="Nächste Seite" className="absolute right-4 top-1/2 z-10 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-ink/90 text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:scale-105 hover:bg-brand focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:right-6" data-id="element-126" data-mp="28padr35m23p1">
                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-127" data-mp="2ds9vj0va0w9m" />
                  </button>
                  <span aria-hidden="true" className="pointer-events-none absolute bottom-5 left-1/2 -translate-x-1/2 rounded-full bg-ink/85 px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-128" data-mp="28ugns3ebru78">
                    {pageIndex + 1} / {total}
                  </span>
                </div>

                <div className="min-w-0 md:pr-4" data-id="element-129" data-mp="1q25oskmskgee">
                  <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-130" data-mp="1q5jt3yf0mzoh">
                    {page.level}
                  </p>
                  <h3 className="mt-2 font-display text-xl font-bold leading-snug text-ink sm:text-2xl" data-id="element-131" data-mp="31haxc59lt95x">
                    {page.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink/60" data-id="element-132" data-mp="s9o52vn2w71i">{page.caption}</p>
                </div>
              </div>
            </article>)}
        </div>

        <p className="mt-3 text-center text-xs font-bold tabular-nums text-ink/40" data-id="element-133" data-mp="ebzklowxb1wz">
          {index + 1} / {total}
        </p>
      </div>
    </section>;
}